export default "__VITE_ASSET__DGDk50N___"